<template>
  <div class="home-mobile">
    <TopNavBarMobile v-if="classExists && !serverError" :classId="classId" :subjectIndex="subjectIndex" />
    
    <div v-if="serverError" class="class-not-exists">
      <div class="not-exists-content">
        <h2>🔧 提示</h2>
        <p>服务器开小差了，请稍后再试！</p>
        <div class="button-group">
          <el-button type="primary" @click="goToLogin" size="large" style="margin-right: 20px;">前往登录</el-button>
          <el-button @click="goToRegister" size="large">前往注册</el-button>
        </div>
      </div>
    </div>
    
    <div v-else-if="!classExists" class="class-not-exists">
      <div class="not-exists-content">
        <h2>⚠️ 提示</h2>
        <p>该班级已删除或不存在！</p>
        <div class="button-group">
          <el-button type="primary" @click="goToLogin" size="large" style="margin-right: 20px;">前往登录</el-button>
          <el-button @click="goToRegister" size="large">前往注册</el-button>
        </div>
      </div>
    </div>
    
    <CorrectionSystemMobileNew v-else :classId="classId" @subjectChange="handleSubjectChange" />
  </div>
</template>

<script>
import TopNavBarMobile from '@/components/mobile/TopNavBarMobile.vue'
import CorrectionSystemMobileNew from '@/components/mobile/CorrectionSystemMobileNew.vue'

export default {
  name: 'HomeMobile',
  components: {
    TopNavBarMobile,
    CorrectionSystemMobileNew
  },
  data() {
    return {
      classExists: true,
      serverError: false,
      subjectIndex: 0
    }
  },
  computed: {
    classId() {
      return this.$route.params.classId ? Number(this.$route.params.classId) : null
    }
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem('mobileNavState', JSON.stringify({
      currentPath: this.$route.path,
      subjectIndex: this.subjectIndex
    }));
    next();
  },
  async created() {
    if (this.classId) {
      try {
        const response = await this.$http.get(`/classes/exists?classId=${this.classId}`);
        
        if (!response.data.exists) {
          this.classExists = false;
        }
      } catch (error) {
        console.error('检查班级存在性失败:', error);
        // 如果是500、502、503、504等服务器错误，显示服务器错误提示而不是班级不存在
        if (error.response && (error.response.status >= 500 && error.response.status < 600)) {
          this.serverError = true;
          this.classExists = null;
        } else {
          this.classExists = false;
        }
      }
    }
    
    this.loadSubjectIndex();
  },
  mounted() {
    document.body.classList.add('mobile-view');
  },
  beforeDestroy() {
    document.body.classList.remove('mobile-view');
  },
  methods: {
    loadSubjectIndex() {
      const savedState = sessionStorage.getItem('mobileNavState');
      if (savedState) {
        try {
          const state = JSON.parse(savedState);
          this.subjectIndex = state.subjectIndex || 0;
        } catch (e) {
          this.subjectIndex = 0;
        }
      }
    },
    handleSubjectChange(index) {
      this.subjectIndex = index;
    },
    goToLogin() {
      this.$router.push('/loginmobile');
    },
    goToRegister() {
      this.$router.push('/signinmobile');
    }
  }
}
</script>

<style scoped>
.home-mobile {
  max-width: 100%;
}

.class-not-exists {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.not-exists-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.not-exists-content h2 {
  font-size: 2.5em;
  color: #f56c6c;
  margin-bottom: 15px;
}

.not-exists-content p {
  font-size: 1.2em;
  color: #606266;
  margin-bottom: 30px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 15px;
}
</style>
